module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss@2-def0e0dd4d19db728e24d3accf13815c.jpg";